import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["uUID"];
/* hs-eslint ignored failing-rules */
/* eslint-disable prefer-const */

import { createRpcClientV2, readUnhandledEnumCase } from 'rpc-client-utils';
import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import appAuthNoRedirectApiClient from './appAuthNoRedirectApiClient';
import { getAlarmsRpc as getAppAlarmsRpc } from '../../__generated__/chirp/com/hubspot/firealarm/rpc/alarms/FireAlarmReadRpc';
import { getAlarmsRpc as getExternalAlarmsRpc } from '../../__generated__/chirp/com/hubspot/firealarm/rpc/alarms/FireAlarmReadRpc-external';
import Alarm from '../model/Alarm';
// @ts-expect-error not typescript
import Severity from '../constants/Severity';
import ApiError from './ApiError';
const appAuthChirpClient = createRpcClientV2({
  hubHttpClient: appAuthNoRedirectApiClient
});
const noAuthChirpClient = createRpcClientV2({
  hubHttpClient: noAuthApiClient
});
function hasMissingHubIdText(value) {
  return typeof value === 'string' && value.includes('HubId is not present');
}

// Walks the rejected error's cause chain looking for an auth failure: a 401, the
// rpc-client isAuthError flag, or a "HubId is not present" message (which the CHIRP
// error surfaces as either message or chirpErrorMessage a few causes deep).
function isAuthFailure(error) {
  let node = error;
  for (let depth = 0; depth < 4; depth++) {
    if (typeof node !== 'object' || node === null) {
      return false;
    }
    if ('isAuthError' in node && node.isAuthError === true || 'status' in node && node.status === 401 || 'message' in node && hasMissingHubIdText(node.message) || 'chirpErrorMessage' in node && hasMissingHubIdText(node.chirpErrorMessage)) {
      return true;
    }
    node = 'cause' in node ? node.cause : null;
  }
  return false;
}
class AlarmApi {
  constructor(dom, storage, events) {
    this.dom = dom;
    this.storage = storage;
    this.events = events;
  }
  getAlarms(appName, callback) {
    const {
      dom,
      storage,
      events
    } = this;
    const hasAppAuth = /^\/(?:[A-Za-z0-9-_]*)\/(\d+)(?:\/|$)/.test(window.location.pathname);
    const i18nWindow = window;
    const request = {
      appName,
      languageKey: i18nWindow.I18n && i18nWindow.I18n.langEnabled ? i18nWindow.I18n.lang : 'en'
    };
    const externalCall = () => noAuthChirpClient.call(getExternalAlarmsRpc, {
      request
    });

    // On app-authenticated pages, attempt the app-auth endpoint first. The custom
    // app-auth client rejects (rather than redirecting to login) when auth fails, so
    // fall back to the unauthenticated external endpoint instead of bouncing the user.
    const responsePromise = hasAppAuth ? appAuthChirpClient.call(getAppAlarmsRpc, {
      request
    }).catch(error => {
      if (isAuthFailure(error)) {
        return externalCall();
      }
      throw error;
    }) : externalCall();
    void responsePromise.then(({
      alarms
    }) => {
      callback(alarms.map(_ref => {
        let {
            uUID
          } = _ref,
          alarmData = _objectWithoutPropertiesLoose(_ref, _excluded);
        const severity = readUnhandledEnumCase(alarmData.severity);
        if (!Severity.getByKey(severity)) {
          return null;
        }
        return new Alarm(Object.assign({}, alarmData, {
          severity,
          uuid: uUID === null || uUID === void 0 ? void 0 : uUID.value
        }), dom, storage, events);
      }).filter(alarm => alarm !== null), null);
    }, error => {
      callback(null, new ApiError(error));
    });
    return true;
  }
}
export default AlarmApi;